import AvatarM from "@common/components/avatar/AvatarM"
import FilledButtonM from "@common/components/button/FilledButtonM"
import { IconImageM } from "@common/components/icons/IconsM"
import TagChipsSelector from "@common/components/TagChipsSelector"
import TextM from "@common/components/text/TextM"
import { useApiStatus } from "@common/hooks/useApiStatus"
import SatisfactionComponent from "@common/liveMode/SatisfactionComponent"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { setOngoingActivity } from "@data/redux/actions/activity"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { setIsLiveModeEnabled } from "@data/redux/actions/liveMode"
import { liveService } from "@data/services/liveService"
import { isArraySubset } from "@data/utility/Utils"
import { useNavigation } from "@react-navigation/native"
import { StatusBar } from "@common/systemBars/StatusBar"
import React, { useContext, useEffect, useState } from "react"
import { Dimensions, View } from "react-native"
import { IconButton } from "react-native-paper"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { connect } from "react-redux"
import liveLogo from "../../../assets/icons/generic/live.png"

const SatisfactionScreen = (props) => {
    const { rating, liveSessionId = null } = props.route.params

    const [score, setScore] = useState(parseInt(rating))
    const [studentComment, setStudentComment] = useState([])
    const [allowStudentCommentSending, setAllowStudentCommentSending] =
        useState(false)

    const dimensions = useContext(DimensionsContext)
    const navigation = useNavigation()
    const insets = useSafeAreaInsets()
    // The id comes from the route: the session may be missing from the student's courses
    const tutor = props.liveSessions?.find(
        (x) => x?.id?.toString() === liveSessionId?.toString()
    )?.tutor

    useEffect(() => {
        if (studentComment?.length > 0) {
            props.apiRequest(
                liveService.sendStudentComment,
                { id: liveSessionId },
                { student_comment: studentComment }
            )
        }
        if (allowStudentCommentSending) {
            props.apiRequest(
                liveService.sendStudentComment,
                { id: liveSessionId },
                { student_comment: null }
            )
            setAllowStudentCommentSending(false)
        }
    }, [studentComment])

    useEffect(() => {
        if (allowStudentCommentSending) setStudentComment([])
    }, [allowStudentCommentSending])

    useEffect(() => {
        if (
            studentComment?.length > 0 &&
            !isArraySubset(
                props.satisfactionStudentComments?.[score],
                studentComment
            )
        ) {
            // console.log("reinitialize student comment")
            setAllowStudentCommentSending(true)
        }
    }, [score])

    useApiStatus(
        liveService.sendStudentComment, // api service
        null, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        () => {}, // success callback
        () => {},
        true
    )

    useApiStatus(
        liveService.sendSatisfaction, // api service
        null, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        () => {
            setStudentComment([])
        }, // success callback
        () => {},
        true
    )

    return (
        <>
            <View
                style={{
                    alignSelf: "center",
                    alignItems: "center",
                    width: Dimensions.get("window").width,
                    marginTop: insets.top,
                    backgroundColor: theme.colors.white,
                    flex: 1,
                }}
            >
                <View
                    style={{
                        flex: 1,
                        alignSelf: "center",
                        alignItems: "center",
                        width: dimensions?.width,
                        // backgroundColor: theme.colors.white
                    }}
                >
                    <View
                        style={{
                            // flex: 1,
                            alignSelf: "center",
                            width: dimensions?.width,
                            // paddingTop: insets.top,
                            // backgroundColor: theme.colors.white
                        }}
                    >
                        <IconButton
                            icon={"times"}
                            iconColor={theme.colors.primary}
                            containerColor={theme.colors.transparent}
                            size={32}
                            style={{}}
                            onPress={() => {
                                if (navigation.canGoBack()) navigation.goBack()
                                else navigation.replace("menu")
                            }}
                        />
                        <View
                            style={{
                                alignSelf: "center",
                                alignItems: "center",
                                marginHorizontal: 10,
                                // width: dimensions?.width,
                            }}
                        >
                            <View
                                style={{
                                    width: 120,
                                    alignItems: "center",
                                }}
                            >
                                <AvatarM
                                    user={tutor}
                                    size={100}
                                    style={{ marginBottom: 20 }}
                                />
                                <IconImageM
                                    source={liveLogo}
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        right: 0,
                                    }}
                                    width={40}
                                />
                            </View>

                            <TextM
                                wrap
                                fontSize={18}
                                fontWeight={"Bold"}
                                color={theme.colors.primary}
                                style={{
                                    marginBottom: 80,
                                    textAlign: "center",
                                }}
                            >
                                Qu’as-tu pensé de cette session live avec{" "}
                                {tutor?.display_name ?? "ton masteur"} ?
                            </TextM>
                            <SatisfactionComponent
                                rating={score}
                                setRating={setScore}
                                withApiRequest
                                requestApiService={liveService.sendSatisfaction}
                                requestRouteParams={{ id: liveSessionId }}
                                ratingBackgroundColor={theme.colors.light}
                                additionalActions={() => {}}
                            />
                            <TextM
                                wrap
                                fontSize={15}
                                color={theme.colors.grey}
                                style={{ marginTop: 20, textAlign: "center" }}
                            >
                                {props.satisfactionSubTitles?.[score]}
                            </TextM>
                            {score !== null &&
                                props.satisfactionStudentComments?.[score] && (
                                    <TagChipsSelector
                                        tags={
                                            props.satisfactionStudentComments[
                                                score
                                            ]
                                        }
                                        selectedTags={studentComment}
                                        onTagToggle={(tag) => {
                                            const isSelected =
                                                studentComment.includes(tag)
                                            if (
                                                isSelected &&
                                                studentComment.length > 1
                                            ) {
                                                setStudentComment(
                                                    studentComment.filter(
                                                        (x) => x !== tag
                                                    )
                                                )
                                            } else if (
                                                isSelected &&
                                                studentComment.length === 1
                                            ) {
                                                setAllowStudentCommentSending(
                                                    true
                                                )
                                            } else {
                                                setStudentComment([
                                                    ...studentComment,
                                                    tag,
                                                ])
                                            }
                                        }}
                                        style={{
                                            marginTop: 80,
                                            width:
                                                dimensions.width < 800
                                                    ? dimensions.width * 0.9
                                                    : null,
                                        }}
                                    />
                                )}
                        </View>
                    </View>
                </View>
            </View>
            <FilledButtonM
                onPress={() => {
                    if (navigation.canGoBack()) navigation.goBack()
                    else navigation.replace("menu")
                }}
                label={"Terminer"}
                color={theme.colors.error}
                style={{
                    alignSelf: "center",
                    position: "absolute",
                    bottom: 0,
                    marginBottom: 30,
                }}
            />
            <StatusBar
                style="dark"
                backgroundColor={theme.colors.white}
                translucent={false}
            />
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        ongoingActivity: state.activity?.ongoingActivity,
        liveSessionId: state.liveMode?.liveSessionId,
        liveSessions: state.data.currentUser?.object?.live_sessions,
        currentLiveSession: state.data.currentUser?.object?.live_sessions?.find(
            (x) => x?.id === state.liveMode?.liveSessionId
        ),
        liveReport: state.liveMode?.liveReport,
        satisfactionStudentComments:
            state.data.staticData?.satisfaction_student_comments,
        satisfactionSubTitles: state.data.staticData?.satisfaction_subtitles,
        isLiveModeEnabled: state.liveMode?.isLiveModeEnabled,
        users: state.data?.users?.usersList,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    setOngoingActivity,
    setIsLiveModeEnabled,
}

export default connect(mapStateToProps, mapDispatchToProps)(SatisfactionScreen)
